import React from 'react';
import { useNavigate } from 'react-router-dom';

const TermsConditions = () => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-black pb-8 safe-area-bottom" data-testid="terms-conditions">
      <div className="p-6 max-w-2xl mx-auto">
        <button onClick={() => navigate(-1)} className="text-[#C6A75E] mb-6" data-testid="back-btn">
          &#8592; Back
        </button>

        <h1 className="font-['Playfair_Display'] text-2xl text-[#C6A75E] mb-8">Terms & Conditions</h1>
        
        <div className="space-y-6 text-[#F5F5F5] text-sm leading-relaxed">
          <section>
            <h2 className="text-[#C6A75E] font-medium mb-2">Service Description</h2>
            <p className="text-[#888888]">
              The External Blueprint is a visual self-enhancement and personal styling service. 
              We provide facial analysis and personalized recommendations based on uploaded photographs.
            </p>
          </section>

          <section>
            <h2 className="text-[#C6A75E] font-medium mb-2">Not Medical or Psychological Advice</h2>
            <p className="text-[#888888]">
              This service does NOT provide medical diagnosis, psychological assessment, or health advice. 
              Our analysis is purely visual and focused on styling, enhancement, and personal reflection. 
              We do not diagnose conditions, infer personality traits, or make health-related claims.
            </p>
          </section>

          <section>
            <h2 className="text-[#C6A75E] font-medium mb-2">No Guarantees</h2>
            <p className="text-[#888888]">
              Results from our service are based on AI-assisted visual analysis and subjective aesthetic 
              principles. We make no guarantees regarding accuracy, outcomes, or suitability of 
              recommendations. Face shape estimations may vary depending on angle, lighting, and image quality.
            </p>
          </section>

          <section>
            <h2 className="text-[#C6A75E] font-medium mb-2">Use at Your Discretion</h2>
            <p className="text-[#888888]">
              All recommendations and insights provided are suggestions only. You are free to use, 
              modify, or disregard any guidance at your own discretion. We encourage you to consult 
              with qualified professionals for specific beauty, health, or styling advice.
            </p>
          </section>

          <section>
            <h2 className="text-[#C6A75E] font-medium mb-2">Limitation of Liability</h2>
            <p className="text-[#888888]">
              The Manifestation Queen and The External Blueprint shall not be liable for any direct, 
              indirect, incidental, or consequential damages arising from the use of this service. 
              By using this service, you acknowledge and accept these limitations.
            </p>
          </section>

          <section>
            <h2 className="text-[#C6A75E] font-medium mb-2">Intellectual Property</h2>
            <p className="text-[#888888]">
              All content, branding, and materials within The External Blueprint are owned by 
              The Manifestation Queen. Your uploaded photos remain your property, but you grant 
              us license to process them for service delivery.
            </p>
          </section>

          <section>
            <h2 className="text-[#C6A75E] font-medium mb-2">Payments & Refunds</h2>
            <p className="text-[#888888]">
              Payments are processed securely via Stripe. Due to the digital nature of our reports, 
              refunds are handled on a case-by-case basis. Contact us within 7 days of purchase 
              for refund requests.
            </p>
          </section>

          <section>
            <h2 className="text-[#C6A75E] font-medium mb-2">Account Termination</h2>
            <p className="text-[#888888]">
              You may delete your account at any time. We reserve the right to terminate accounts 
              that violate these terms or misuse our service.
            </p>
          </section>

          <section>
            <h2 className="text-[#C6A75E] font-medium mb-2">Changes to Terms</h2>
            <p className="text-[#888888]">
              We may update these terms periodically. Continued use of the service after changes 
              constitutes acceptance of the new terms.
            </p>
          </section>

          <p className="text-[#888888] text-xs mt-8">Last updated: April 2026</p>
        </div>

        <footer className="text-center text-[#888888] text-xs mt-12 pt-6 border-t border-[rgba(198,167,94,0.2)]">
          Created by The Manifestation Queen
        </footer>
      </div>
    </div>
  );
};

export default TermsConditions;
